// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/headerSearch/index.less
// module id = 88
// module chunks = 0